<template>
	<div class="isStylePageContent">
		<h4 class="form-block-title">儲值點數折扣</h4>
		<FormItemGroup v-if="renderList.length > 0 && submitData.length > 0" :renderList="renderList" :defaultValue="submitData" type="deposit"
			@updateSubmitData="updateSubmitData" />
	</div>
</template>
  
<script>
import memberLevelDiscountMixin from '@src/mixins/memberLevelDiscountMixin'
import lazyLoadComponent from '@router/lazyload-component'
export default {
	name: 'MemberLevelSettingStep2Deposit',
	data() {
		return {
			renderList: [], // 純服務列表
			submitData: [], // 此次要渲染的資料(includeDBData)
		};
	},
	props: {},
	watch: {},
	mixins: [memberLevelDiscountMixin],
	computed: {
	},
	inject: ['dbData', 'isEdit'],
	created() { },
	async mounted() {
		await this.fetchList()
		this.composeSubmitData()
	},
	methods: {
		async fetchList() {
			const { items } = await this.$store.dispatch('deposit/fetchListAll', {
				"paginate": 0
			})
			this.renderList = items
		},
		/**
		 * @description 組成submitData
		 */
		composeSubmitData() {
			try {
				this.submitData = this.renderList.reduce((accu, cur) => {
					let rawObj = this.idFormat('service')
					rawObj = this.findDiscountInDb(cur.id, rawObj)
					accu.push(rawObj)
					return accu
				}, [])
			} catch (error) {
				console.error(error.message)
			}
		},
		/**
		 * @description 找到已存的discount修改值(for修改初始化) & 放到畫面上
		 * @param {*} id 
		 * @param {*} rawObj 
		 */
		findDiscountInDb(id, rawObj) {
			try {
				rawObj['id'] = id
				const index = this.dbData['deposits'] ? this.dbData['deposits'].findIndex(item => item.id === id) : -1
				if (index > -1) {
					rawObj['discount'] = parseInt(this.dbData['deposits'][index].discount)
					rawObj['discountType'] = this.dbData['deposits'][index].discountType
				}
				return rawObj
			} catch (error) {
				console.error(error.message)
			}
		},
	},
	components: {
		FormItemGroup: () => lazyLoadComponent(import('./FormItemGroup')),
	},
};
</script>
  
<style lang="scss" module></style>
  